import React from 'react';

import { useAppState } from 'hooks/useAppState';
import { useServices } from 'hooks/useServices';
import { useAsyncBoundary } from 'utils/asyncBoundary/asyncBoundaryHooks';
import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { UnauthorizedError } from 'utils/errors';

export const useAuthProcess = () => {
  const { authType, user } = useAppState();

  const { getUser } = useServices();

  const { injectPromise } = useAsyncBoundary();

  const dispatch = useAppDispatcher();

  const shouldUpdateUser = React.useMemo(() => {
    // Отсутствие типа авторизации предполагается только в ситуации
    // только что открытой страницы.
    if (authType === null) {
      return true;
    }

    // В случае MANUAL авторизации и отсутствия данных об аккаунте
    // вызывается сервис на получение информации об аккаунте.
    if (!user && authType === 'MANUAL') {
      return true;
    }

    return false;
  }, [authType, user]);

  React.useLayoutEffect(() => {
    if (shouldUpdateUser) {
      injectPromise(
        getUser()
          .then((user) => {
            dispatch({
              name: 'AuthProcess__UserRecieved',
              user,
              authType,
            });
          })
          .catch((error) => {
            if (error instanceof UnauthorizedError) {
              dispatch({
                name: 'AuthProcess__AuthFailed',
              });
            } else {
              throw error;
            }
          })
      );
    }
  }, [authType, dispatch, getUser, injectPromise, shouldUpdateUser]);
};
